import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Blog, BlogSingleTitle } from "../../../../Constants/Constants";
import { BlogBody } from "./BlogBody/BlogBody";
import BlogFilter from "./BlogFilter/BlogFilter";

const BlogGridsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BlogSingleTitle} parent={Blog} />
      <Container fluid className="blog-grid-page">
        <Row>
          <BlogBody />
          <BlogFilter />
        </Row>
      </Container>
    </>
  );
};

export default BlogGridsContainer;
